import React from 'react';
import merge from 'classnames';

import { ProgressSpinner } from '@/components/generic/ProgressSpinner';

import { Props } from './types';

import styles from './RequestStatusBar.module.scss';

export const RequestStatusBar = ({ loading, messages, classes = {}, testIds }: Props) => {
  const renderMessage = () => {
    switch (true) {
      case loading:
        return (
          <>
            <span>
              <ProgressSpinner
                classes={{ spinner: merge(styles.loader, classes.loader) }}
                size={15}
              />
            </span>
            <span className={classes.message}>{messages.inProgress}...</span>
          </>
        );

      case Boolean(messages.error):
        return (
          <span
            className={merge(styles.error_message, classes.message)}
            data-testid={testIds?.errorMessage ?? `request-status-bar-error`}
          >
            {messages.error}
          </span>
        );

      case Boolean(messages.success):
        return (
          <span
            className={merge(styles.success_message, classes.message)}
            data-testid={testIds?.successMessage ?? `request-status-bar-success`}
          >
            {messages.success}
          </span>
        );

      default:
        return null;
    }
  };

  return (
    <div className={merge(styles.message, classes.container)} data-testid="request-status-bar">
      {renderMessage()}
    </div>
  );
};
